import styled from "styled-components"

const ModalTitle = styled.div`
  padding-top: 22px;
  padding-bottom: 11px;
  padding-left: 50px;
  padding-right: 50px;
  font-size: ${props => props.theme.font.size.title};
  margin: -22px -25px;
  margin-bottom: 20px;
`

export default ModalTitle
